//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import utils from '@/js/utils';
import DataProfilingService from '@/apps/data-platform/services/data_quality/data_profiling_service';
import BaseLoading from '@/components/BaseLoading';
export default {
  name: 'DataStudioDashboard',
  components: {
    BaseLoading: BaseLoading
  },
  data: function data() {
    return {
      url: '',
      isLoading: false,
      params: {}
    };
  },
  created: function created() {
    this.getUrl();
  },
  methods: {
    getUrl: function getUrl() {
      var _this = this;
      this.isLoading = true;
      DataProfilingService.getDashBoardParams().then(function (response) {
        _this.params = response.data.params;
        var urlBase = response.data.base_data_studio_url;
        var paramsAsString = JSON.stringify(_this.params);
        var paramsEncoded = encodeURIComponent(paramsAsString);
        _this.url = "".concat(urlBase, "?params=").concat(paramsEncoded);
        _this.isLoading = false;
      }).catch(function (e) {
        utils.printError(e);
      });
    }
  }
};